import { b, a } from './chunk-FUQLNXR2.mjs';
import { jsx } from 'react/jsx-runtime';

var s=l=>jsx("svg",b(a({xmlns:"http://www.w3.org/2000/svg",height:"1em",viewBox:"0 0 576 512"},l),{children:jsx("path",{d:"M112 96c-26.5 0-48 21.5-48 48V256h96V144c0-26.5-21.5-48-48-48zM0 144C0 82.1 50.1 32 112 32s112 50.1 112 112V368c0 61.9-50.1 112-112 112S0 429.9 0 368V144zM576 320c0 38.4-13.5 73.7-36.1 101.3L314.7 196.1C342.3 173.5 377.6 160 416 160c88.4 0 160 71.6 160 160zM416 480c-88.4 0-160-71.6-160-160c0-38.4 13.5-73.7 36.1-101.3L517.3 443.9C489.7 466.5 454.4 480 416 480z",fill:"currentColor"})})),t=s;

export { t as a };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-2JBMKIOA.mjs.map